import styled from 'styled-components'

export const Ring = styled.div`
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 8;
    border-radius: inherit;
    transform: scale(1);
    border: 2px solid #ffeafd;
    box-shadow: 0px 0px 9px 2px #ff1ef6;
`
